import ApiService from './api.service';
import ApiError from '../exceptions/api.error';
import { ConfigItemDTO } from '@/models/ConfigItemDTO';
import { AxiosResponse } from 'axios';
import { CenterDTO, CenterAvailableDTO } from '@/models/CenterDTO';
import { PUBLIC_ROOT_API } from '@/config/app.config';

export default class CenterService {

    public static async fetchCenters(): Promise<AxiosResponse<CenterDTO>> {
        return await ApiService.get('/Center/get-all')
            .then((value: AxiosResponse) => {
                return value.data as AxiosResponse<CenterDTO>;
            });
    }

    public static async getCenterById(centerId: number): Promise<CenterDTO> {
        return await ApiService.get(`rdv/Center/get-center-by-id/${centerId}`)
            .then((value: AxiosResponse) => {

                return value.data as CenterDTO;
            }).catch
            ((err) => {
              ApiService.get(`rdv/Center/test`);

              throw new ApiError(err.response.status, err.response.data.message);

            });
    }


}
